// extracted by mini-css-extract-plugin
module.exports = {"cartButton":"CartButton_cartButton__n2lAi","badge":"CartButton_badge__5HPL9"};